import React from 'react'
import Lang from "@components/Lang/Lang";
import {getQueryString} from '@utils/utils';
import {Button} from "antd";
/**
 * 成功显示
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 *
 **/

export default class Success extends React.Component {
    static defaultProps = {
        afterId:''
    };
    goBack(){
        const containerId = getQueryString("containerId");
        if(containerId){
            this.props.history.push("/shipperManagement/shippingOrder/detail?"+containerId)
        }
    }
    render() {
        const {  afterId,  } = this.props;
        return ( <div className="black89 text-center font_14 pt_40 pb_40">
            <div className={"mb_20"}>
                <img src="https://oss.essaone.com/9c92ba53-f64e-4873-9850-20f0fdde7ca5.png" />
            </div>
            <div className={"fw_700 font_18"}>
                {Lang({id:'TiJiaoChengGongQingDengDaiKeHuChuLi',default:"提交成功，请等待客户处理"})}
            </div>
            <div className={"mt_20 mb_40"}>
                <Button  size={"large"}
                         onClick={()=>this.goBack()}>
                    {Lang({id:'FanHui',default:"返回"})}
                </Button>
                {/* 索赔详情 */}
               {afterId&&<Button className={"ml_12"}
                        href={`/afterSale/claim-demage-info?id=${afterId}`}
                        size={"large"}>
                    {Lang({id:'ShouHouXiangQing',default:"售后详情"})}
                </Button>}
            </div>
        </div>);
    }
}
